/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../../tools/typings/google.maps/google.maps.d.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class MapController {
        public static $inject: string[] = [
            '$timeout',
            'NgMap',
            'GoogleMapsUrl',
            '$mobilityCompanyAuthentication',
            'ConvertUnits',
        ];

        private _map: any;
        private _markers: any;
        private _selectedMarker: any;
        private isMetric: boolean;

        public mapId: string;
        public config: any;
        public filters: any;

        constructor(public $timeout: any,
                    public NgMap: any,
                    public GoogleMapsUrl: string,
                    public $mobilityCompanyAuthentication: any,
                    public ConvertUnits: any) {
            var _self = this;
            this.isMetric = $mobilityCompanyAuthentication.location.settings.metric;
            this.NgMap.getMap(this.mapId).then(function(map: any) { _self._map = map; });
        }

        public get map() : any {
            return this._map ? this._map : undefined;
        }

        public get center() : any {
            return this.map ? this.map.center : undefined;
        }

        public set center(center: any) {
            if (this.NgMap) {
                this.NgMap.getMap(this.mapId).then(function(map: any) {
                    map.setCenter(new google.maps.LatLng(center.lat, center.lng));
                });
            }
        }

        public get zoom() : number {
            return this.map ? this.map.zoom : undefined;
        }

        public set zoom(zoom: number) {
            if (this.NgMap) {
                this.NgMap.getMap(this.mapId).then(function(map: any) {
                    map.setZoom(zoom);
                });
            }
        }

        public get markers() : any {
            return this._markers;
        }

        public set markers(markers: any) {
            var _self = this;
            this._markers = [];

            if (this.NgMap) {
                if (markers.length) {
                    for (var marker of markers) {
                        if (marker.data.latitude && marker.data.longitude) {
                            _self._markers.push(marker);
                        }
                    }
                }

                this.NgMap.getMap(this.mapId).then(function(map: any) {
                    _self.$timeout(function() {
                        google.maps.event.trigger(map, 'resize');
                    }, 500);
                });
            }
        }

        public get selectedMarker() : any {
            return this._selectedMarker;
        }

        public set selectedMarker(marker: any) {
            this._selectedMarker = marker;
        }

        public getSelectedMarkerValue(key: any) {
            const marker = this._selectedMarker;
            if (!(marker && marker.data)) return null;

            return marker.data[key];
        }

        public get selectedMarkerMileage(): string {
            const lastCarScan = this.getSelectedMarkerValue('last_connected_car_scan');

            if (!lastCarScan) return 'Unavailable';

            const mileageInKm = lastCarScan.mileage_in_km;
            const convertedValue = this.isMetric
                ? mileageInKm
                : this.ConvertUnits.kmToMiles(mileageInKm);
            return convertedValue.toFixed();
        }

        public get selectedMarkerDisconnected(): string {
            return this._selectedMarker.data.event_type === 'power_cut' ? '(Disconnected)' : '';
        }

        public onMapLoaded() {
            var _self = this;

            this.NgMap.getMap(this.mapId).then(function(map: any) {
                // do not show the pegman for street view
                map.setOptions({ streetViewControl: false });
                google.maps.event.trigger(map, 'resize');
            });
        }

        public lookupMarkerIcon(marker: any) : string {
            var color = 'fe7569';

            if (this.config && this.config.hasOwnProperty('markerColors')) {
                if (typeof(this.config.markerColors) === 'string') {
                    color = this.config.markerColors;
                } else if (this.config.markerColors.hasOwnProperty(marker.data[this.config.markerKey])) {
                    color = this.config.markerColors[marker.data[this.config.markerKey]];
                }
            }

            return '../../images/map/markers/' + color + '.png';
        }

        public showInfoWindow(e: any, markerId: string, marker: any, ctrl: any) : void {
            ctrl.selectedMarker = marker;
            if (ctrl.map && ctrl.map.showInfoWindow) {
                ctrl.map.showInfoWindow('marker-info', markerId);
            }
        }
    }

    getDealerwareWebComponentsModule().controller('MapController', MapController);

    export class MapDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'MapController';
        public controllerAs     : string    =   'mapController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {
            mapId: '=',
            config: '=',
            center: '=',
            zoom: '=',
            markers: '=',
            filters: '='
        };
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/map/map_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {}
    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareMap",() => new MapDirective());
}
